// extracted by mini-css-extract-plugin
module.exports = {"toiCube":"_MfoH","openInAppVisible":"plBvX","shiftUp":"TNGgb","slider3d":"ge6Zn","videolist":"J07Gv","videoshow":"v_Mrz","hidden":"Hsae2","cubeClass":"c9TIi","articleshow":"B2aMt"};